import {IResource} from "../../../models/game/IResource";
import {ITable} from "../../../models/game/ITable";
import {IHand} from "../../../models/game/IHand";
import {ICpuPlayedCard, IPlayedCard} from "../../../models/game/IPlayedCard";
import {IAD} from "../../../models/game/IAD";
import {IEndGame} from "../../../models/game/IEndGame";
import {IMessage} from "../../../models/game/IMessage";
import {ICounters} from "../../../models/game/ICounters";
import {ICpuData} from "../../../models/game/ICpuData";

export interface GameState {
    activeCpu: any,
    game: any,
    gamePvPData: any,
    phase: null|string,
    playerFire:IResource,
    playerDiamond:IResource,
    playerPow:IResource,
    playerHp:number,
    playerHand:IHand,
    playerTable:ITable,
    playerTurn:number,
    playerMulligan:boolean,
    playerAD:IAD,

    counters:ICounters,

    cpuData: ICpuData,

    cpuFire:IResource,
    cpuDiamond:IResource,
    cpuPow:IResource,
    cpuHp:number,

    cpuTable:ITable,

    playedCard:IPlayedCard,
    cpuPlayedCard: ICpuPlayedCard,

    endGame: IEndGame,
    message: IMessage,

    isPvP: boolean,

    isPlaySpellDrag:boolean,
    touchDragCoords: any,
    battleBg: string,
    isLoading : boolean,
}

export enum GameActionEnum {
    SET_IS_BATTLE_LOADING = "SET_IS_BATTLE_LOADING",
    SET_BATTLE_BG = 'SET_BATTLE_BG',
    SET_CPU = "SET_CPU",
    SET_CPU_DATA = 'SET_CPU_DATA',
    SET_GAME = "SET_GAME",
    SET_GAME_PVP_DATA = 'SET_GAME_PVP_DATA',
    SET_PHASE = 'SET_PHASE',
    SET_PLAYER_FIRE = 'SET_PLAYER_FIRE',
    SET_PLAYER_DIAMOND = 'SET_PLAYER_DIAMOND',
    SET_PLAYER_POW = 'SET_PLAYER_POW',
    SET_PLAYER_HP = 'SET_PLAYER_HP',
    SET_PLAYER_TABLE = 'SET_PLAYER_TABLE',
    SET_PLAYER_HAND = 'SET_PLAYER_HAND',
    SET_PLAYER_AD = 'SET_PLAYER_AD',

    SET_PLAYER_TURN = 'SET_PLAYER_TURN',
    SET_PLAYER_MULLIGAN = 'SET_PLAYER_MULLIGAN',

    SET_COUNTERS = 'SET_COUNTERS',

    SET_CPU_FIRE = 'SET_CPU_FIRE',
    SET_CPU_DIAMOND = 'SET_CPU_DIAMOND',
    SET_CPU_POW = 'SET_CPU_POW',
    SET_CPU_HP = 'SET_CPU_HP',
    SET_CPU_TABLE = 'SET_CPU_TABLE',

    SET_PLAYED_CARD = 'SET_PLAYED_CARD',
    SET_CPU_PLAYED_CARD = 'SET_CPU_PLAYED_CARD',

    SET_END_GAME = 'SET_END_GAME',

    SET_MESSAGE = 'SET_MESSAGE',

    SET_IS_PVP = 'SET_IS_PVP',
    SET_IS_PLAY_SPELL_DRAG = 'SET_IS_PLAY_SPELL_DRAG',
    SET_TOUCH_DRAG_COORDS = 'SET_TOUCH_DRAG_COORDS'

}

export interface SetIsLoading {
    type: GameActionEnum.SET_IS_BATTLE_LOADING;
    payload: boolean;
}

export interface SetPlayerTurnAction {
    type: GameActionEnum.SET_PLAYER_TURN;
    payload: number;
}

export interface SetPlayerMulliganAction {
    type: GameActionEnum.SET_PLAYER_MULLIGAN;
    payload: boolean;
}

export interface SetBattleBg {
    type: GameActionEnum.SET_BATTLE_BG;
    payload: string;
}
export interface SetIsPvPAction {
    type: GameActionEnum.SET_IS_PVP;
    payload: boolean;
}

export interface SetCpuAction {
    type: GameActionEnum.SET_CPU;
    payload: any;
}
export interface SetCpuDataAction {
    type: GameActionEnum.SET_CPU_DATA;
    payload: ICpuData;
}
export interface SetGameAction {
    type: GameActionEnum.SET_GAME;
    payload: any;
}
export interface SetGamePvPDataAction {
    type: GameActionEnum.SET_GAME_PVP_DATA;
    payload: any;
}
export interface SetPhaseAction {
    type: GameActionEnum.SET_PHASE;
    payload: any;
}
export interface SetPlayerFireAction {
    type: GameActionEnum.SET_PLAYER_FIRE;
    payload: IResource;
}
export interface SetPlayerDiamondAction {
    type: GameActionEnum.SET_PLAYER_DIAMOND;
    payload: IResource;
}
export interface SetPlayerPowAction {
    type: GameActionEnum.SET_PLAYER_POW;
    payload: IResource;
}
export interface SetPlayerHpAction {
    type: GameActionEnum.SET_PLAYER_HP;
    payload: number;
}
export interface SetPlayerTableAction {
    type: GameActionEnum.SET_PLAYER_TABLE;
    payload: ITable;
}
export interface SetPlayerHandAction {
    type: GameActionEnum.SET_PLAYER_HAND;
    payload: IHand;
}
export interface SetPlayerADAction {
    type: GameActionEnum.SET_PLAYER_AD;
    payload: IAD;
}
export interface  SetCountersAction {
    type: GameActionEnum.SET_COUNTERS;
    payload: ICounters
}
export interface SetCpuFireAction {
    type: GameActionEnum.SET_CPU_FIRE;
    payload: IResource;
}
export interface SetCpuDiamondAction {
    type: GameActionEnum.SET_CPU_DIAMOND;
    payload: IResource;
}
export interface SetCpuPowAction {
    type: GameActionEnum.SET_CPU_POW;
    payload: IResource;
}
export interface SetCpuHpAction {
    type: GameActionEnum.SET_CPU_HP;
    payload: number;
}
export interface SetCpuTableAction {
    type: GameActionEnum.SET_CPU_TABLE;
    payload: ITable;
}
export interface SetPlayedCardAction {
    type: GameActionEnum.SET_PLAYED_CARD;
    payload: IPlayedCard;
}
export interface SetCpuPlayedCardAction {
    type: GameActionEnum.SET_CPU_PLAYED_CARD;
    payload: ICpuPlayedCard;
}

export interface SetEndGameAction {
    type: GameActionEnum.SET_END_GAME;
    payload: IEndGame;
}

export interface SetMessageAction {
    type: GameActionEnum.SET_MESSAGE;
    payload: IMessage
}

export interface  SetIsPlaySpellDrag {
    type:GameActionEnum.SET_IS_PLAY_SPELL_DRAG;
    payload: boolean
}

export interface SetTouchDragCoords {
    type:GameActionEnum.SET_TOUCH_DRAG_COORDS;
    payload: any
}




export type GameAction =
    SetCpuAction |
    SetCpuDataAction |
    SetGameAction |
    SetGamePvPDataAction |
    SetPhaseAction |
    SetCpuTableAction |
    SetCpuHpAction |
    SetCpuPowAction |
    SetCpuDiamondAction |
    SetCpuFireAction |
    SetPlayerHandAction |
    SetPlayerTableAction |
    SetPlayerPowAction |
    SetPlayerHpAction |
    SetPlayerDiamondAction |
    SetPlayerFireAction |
    SetPlayedCardAction |
    SetPlayerADAction |
    SetPlayerTurnAction |
    SetPlayerMulliganAction |
    SetCpuPlayedCardAction |
    SetEndGameAction |
    SetMessageAction |
    SetIsPvPAction |
    SetCountersAction |
    SetIsPlaySpellDrag |
    SetTouchDragCoords |
    SetIsLoading |
    SetBattleBg;


